import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import KaabaImage from 'shared/images/kaaba.webp'
import { Button } from 'shared/ui/button'
import { ImageLazy } from 'shared/ui/image-lazy'

import s from './styles.module.scss'

interface Props {
  onClick: () => void
}

export const UmrahSuccess = ({ onClick }: Props) => {
  const { t } = useTranslation()

  return (
    <div className={clsx('safe-area-top-padding', s.container)}>
      <div className={s.box}>
        <ImageLazy
          src={KaabaImage}
          alt={'image'}
          className={s.image}
        />
        <div className={s.info}>
          <p className={clsx('bold-24', s.title)}>
            {t('umrah_block.success_advance')}
          </p>
          <p className={clsx('medium-14', s.subtitle)}>
            {t('umrah_block.recall_advance')}
          </p>
        </div>

        <Button
          variant={'grey'}
          className={clsx('bold-17', s.button)}
          onClick={onClick}
        >
          {t('umrah_block.my_orders')}
        </Button>
      </div>
    </div>
  )
}
